import React from 'react';
import InlineForm from '@plone/volto/components/manage/Form/InlineForm';
import { Icon, SidebarPortal } from '@plone/volto/components';
import fastForwardSVG from '@plone/volto/icons/fast-forward.svg';
import QuicklinksSchema from './schema';
import View from './View';

const Edit = (props) => {
  const schema = QuicklinksSchema(
    props.intl,
    props.metadata || props.properties,
  );
  return (
    <>
      <SidebarPortal selected={props.selected}>
        <InlineForm
          schema={schema}
          title={schema.title}
          icon={<Icon name={fastForwardSVG} />}
          onChangeField={(id, value) => {
            props.onChangeBlock(props.block, {
              ...props.data,
              [id]: value,
            });
          }}
          formData={props.data}
        />
      </SidebarPortal>
      <View data={props.data} isEditMode={true} />
    </>
  );
};

export default Edit;
